/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import {
    Badge, List, ListItemText, Tooltip,
} from 'appkit-react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import ErrorView from 'views/Shared/components/ErrorView';
import Loader from 'views/Shared/components/Loader';
import { ReconStatusTypeEnum } from '../../../../constants/index';
import ArchiveProject from '../../Projects/ArchiveProject';
import ProjectList from '../components/ProjectList';

const ProjectListContainer = ({
    mainData, refetchProjectHierarchy, tenantId, projectHierarchyIsLoading, projectHierarchyIsError, setToastMessage,
}) => {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [dataForUpdate, setDataForUpdate] = useState({});
    const [dataForClone, setDataForClone] = useState({});
    const [copyProjectFlag, setCopyProjectFlag] = useState(false);
    const [searchString, setSearchString] = useState('');

    const [projects, setProjects] = useState(mainData);

    /* ToolTip Menu */
    const MenuTooltip = ({ data }) => (
        <div>
            <List>
                <ListItemText
                    onClick={
                        () => {
                            setShowModal(true);
                            setDataForUpdate(data);
                            setDataForClone({});
                        }
                    }
                >
                    Edit
                </ListItemText>
                <ListItemText onClick={() => {
                    setShowModal(true);
                    setDataForClone(data);
                    setCopyProjectFlag(true);
                    setDataForUpdate({});
                }}
                >
                    Clone
                </ListItemText>
                <ArchiveProject tenantId={tenantId} project={data} fetchData={refetchProjectHierarchy} setToastMessage={setToastMessage} />
            </List>
        </div>
    );

    const getBadgeType = status => {
        let type;
        switch (status) {
            case ReconStatusTypeEnum.SUCCESS:
                type = 'success';
                break;
            case ReconStatusTypeEnum.INPROGRESS:
                type = 'warning';
                break;
            case ReconStatusTypeEnum.NOTSTARTED:
                type = 'secondary';
                break;
            default:
                type = 'error';
                break;
        }
        return type;
    };

    const navigateToDataLineageUpload = project => {
        history.push({
            pathname: '/data-lineage-upload',
            state: {
                tenantId, project,
            },
        });
    };

    const navigateToReconResult = project => {
        history.push({
            pathname: '/datareconresult',
            state: {
                tenantId, project,
            },
        });
    };

    const getProjectNameSpan = data => (
        <span
            role="presentation"
            onClick={() => { navigateToDataLineageUpload(data); }}
        >
            {`${data.projectName}`}
        </span>
    );

    const getReconStatusBadge = data => (
        <>
            {(data.reconRunStatus === ReconStatusTypeEnum.SUCCESS)
                && (
                    <Tooltip content={`${data.reconRunStatus === ReconStatusTypeEnum.SUCCESS ? 'View Results' : ''}`} placement="left" tooltipTheme="light">
                        <Badge
                            className="cursor-pointer"
                            type={getBadgeType(data.reconRunStatus)}
                            onClick={() => {
                                navigateToReconResult(data);
                            }}
                        >
                            <span>{ReconStatusTypeEnum.COMPLETE}</span>
                        </Badge>
                    </Tooltip>
                )}

            {(data.reconRunStatus !== ReconStatusTypeEnum.SUCCESS)
                && (
                    <Badge
                        type={getBadgeType(data.reconRunStatus)}
                    >
                        <span>{data.reconRunStatus}</span>
                    </Badge>
                )}
        </>
    );

    const ToolTip = ({ data }) => {
        const props = {
            data,
        };
        return (
            <div className="menu-icon">
                <Tooltip
                    content={MenuTooltip(props)}
                    trigger="click"
                    refClassName="a-account-info"
                    className="a-account-options"
                    clickToClose
                    tooltipTheme="light"
                    style={{ zIndex: 100, width: '150px' }}
                >
                    <span className="appkiticon icon-vertical-more-fill a-font-16 a-text-orange" aria-hidden="true" style={{ cursor: 'pointer' }} />
                </Tooltip>
            </div>
        );
    };

    /* Parent Projects Table Columns */
    const columns = [
        {
            expander: true,
            Expander: ({ isExpanded, ...rest }) => {
                if (rest.original.children.length > 0) {
                    return (
                        <div>
                            {isExpanded ? (
                                <span className="rt-expander -open" style={{ marginBottom: '0.3rem' }} />
                            ) : (
                                <span className="rt-expander" style={{ marginBottom: '0.3rem' }} />
                            )}
                        </div>
                    );
                }
                return <span className=" rt-td rt-expander" />;
            },
        },
        {
            Header: 'ID',
            accessor: 'projectDisplayId',
            minWidth: 90,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Project Name',
            accessor: 'projectName',
            minWidth: 150,
            resizable: true,
            sortable: true,
            style: { cursor: 'pointer' },
            Cell: ({ original }) => getProjectNameSpan(original),
        },
        {
            Header: 'Description',
            accessor: 'projectDesc',
            minWidth: 240,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Project Owner',
            accessor: 'ownerName',
            minWidth: 140,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Project Status',
            accessor: 'status',
            minWidth: 105,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { status } } = row;
                return (
                    <span>{`${status && status[0].toUpperCase() + status.slice(1)}`}</span>
                );
            },
        },
        {
            Header: 'Reconciliation Status',
            accessor: 'reconStatus',
            minWidth: 115,
            resizable: true,
            sortable: true,
            Cell: ({ original }) => getReconStatusBadge(original),
        },
        {
            Header: '',
            accessor: '',
            minWidth: 35,
            resizable: true,
            Cell: ({ original }) => {
                const props = {
                    data: original,
                };
                return ToolTip(props);
            },
        },
    ];

    /* Sub Projects Table Columns */
    const subColumns = [
        {
            expander: true,
            Expander: ({ isExpanded, ...rest }) => {
                if (rest.original.children && rest.original.children.length > 0) {
                    return (
                        <div>
                            {isExpanded ? (
                                <span className="rt-expander -open" style={{ marginBottom: '0.3rem' }} />
                            ) : (
                                <span className="rt-expander" style={{ marginBottom: '0.3rem' }} />
                            )}
                        </div>
                    );
                }
                return <span className=" rt-td rt-expander" />;
            },
        },
        {
            accessor: 'projectDisplayId',
            minWidth: 90,
            resizable: true,
        },
        {
            accessor: 'projectName',
            minWidth: 150,
            resizable: true,
            style: { cursor: 'pointer' },
            Cell: ({ original }) => getProjectNameSpan(original),
        },
        {
            accessor: 'projectDesc',
            minWidth: 240,
            resizable: true,
        },
        {
            accessor: 'ownerName',
            minWidth: 140,
            resizable: true,
        },
        {
            accessor: 'status',
            minWidth: 70,
            resizable: true,
        },
        {
            accessor: 'reconStatus',
            minWidth: 110,
            resizable: true,
            Cell: ({ original }) => getReconStatusBadge(original),
        },
        {
            Header: '',
            accessor: '',
            disableSortBy: true,
            resizable: true,
            minWidth: 35,
            Cell: ({ original }) => {
                const props = {
                    data: original,
                };
                return ToolTip(props);
            },
        },
    ];

    /* side effect to set projects when mainData is changed */
    useEffect(() => {
        setProjects(mainData || []);
    }, [mainData]);

    /* side effect to set projects when filterString is changed */
    useEffect(() => {
        const searchStr = searchString.trim().toLowerCase();
        if (searchString.length > 0) {
            setProjects(mainData.filter(e => e.projectName.toLowerCase().match(searchStr)));
        } else {
            setProjects(mainData);
        }
    }, [searchString]);

    if (projectHierarchyIsLoading) {
        return <Loader />;
    }

    if (projectHierarchyIsError) {
        return <ErrorView />;
    }

    return (
        <ProjectList
            columns={columns}
            subColumns={subColumns}
            projects={projects}
            showModal={showModal}
            setShowModal={setShowModal}
            dataForUpdate={dataForUpdate}
            tenantId={tenantId}
            dataForClone={dataForClone}
            copyProjectFlag={copyProjectFlag}
            setCopyProjectFlag={setCopyProjectFlag}
            refetch={refetchProjectHierarchy}
            searchString={searchString}
            setSearchString={setSearchString}
            projectHierarchyIsLoading={projectHierarchyIsLoading}
            projectHierarchyIsError={projectHierarchyIsError}
            setToastMessage={setToastMessage}
        />
    );
};

export default ProjectListContainer;
